import { Howl } from 'howler'

export enum PrologueSounds {
  Aeron1 = 1,
  Aeron2 = 2,
  Aeron3 = 3,
  Aeron4 = 4,
  Aeron5 = 5,
  Echo1 = 6,
  Echo2 = 7,
  Echo3 = 8,
  Echo4 = 9,
}

const phraseToAudioMap: Record<PrologueSounds, string> = {
  [PrologueSounds.Aeron1]: '/sounds/prologue/Prologue_Aeron_full_Good_01.mp3',
  [PrologueSounds.Aeron2]: '/sounds/prologue/Prologue_Aeron_full_Good_02.mp3',
  [PrologueSounds.Aeron3]: '/sounds/prologue/Prologue_Aeron_full_Good_03.mp3',
  [PrologueSounds.Aeron4]: '/sounds/prologue/Prologue_Aeron_full_Good_04.mp3',
  [PrologueSounds.Aeron5]: '/sounds/prologue/Prologue_Aeron_full_Good_05.mp3',
  [PrologueSounds.Echo1]: '/sounds/prologue/Prologue_Echo_Full_good_01.mp3',
  [PrologueSounds.Echo2]: '/sounds/prologue/Prologue_Echo_Full_good_02.mp3',
  [PrologueSounds.Echo3]: '/sounds/prologue/Prologue_Echo_Full_good_03.mp3',
  [PrologueSounds.Echo4]: '/sounds/prologue/Prologue_Echo_Full_good_04.mp3',
}

const sounds: Partial<Record<PrologueSounds, Howl>> = {}
let currentSound: Howl | null = null

export const preloadSounds = () => {
  for (const [name, src] of Object.entries(phraseToAudioMap)) {
    const key = Number(name) as PrologueSounds

    if (!sounds[key]) {
      sounds[key] = new Howl({
        src: [src],
        preload: true,
        volume: 1.0,
      })
    }
  }
}

export const playSound = (name: PrologueSounds) => {
  stopCurrentSound()
  const sound = sounds[name]
  if (sound) {
    sound.play()
    currentSound = sound
  }
}

export const stopCurrentSound = () => {
  if (currentSound) {
    currentSound.stop()
    currentSound = null
  }
}

export const unloadAllSounds = () => {
  Object.values(sounds).forEach((sound) => {
    sound.unload()
  })
  Object.keys(sounds).forEach((key) => {
    delete sounds[Number(key) as PrologueSounds]
  })
  currentSound = null
}
